import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { SubscribeSimplifiedModalForm } from './form/SubscribeSimplifiedModalForm'
import { SubscribeSimplifiedModalTypeEnum } from '../utils/subscribe-simplified-modal-type.enum'
import { HelperTextProps } from '../../login-modal-subscribe/helper-text/HelperText'
import { getHomePathname } from '../../../../../utils/house-explorer-url-params.helper'
import { IconSvg } from '../../../../atoms'
import { useSeminarAppContext } from '../../../../contexts'
import { Modal } from '../../../../molecules'

const SubscribeSimplifiedAccesResultsModal = ({
  onAccessResults,
  isLoading,
  setModalSubscribeSimplifiedType,
  helperText,
}: {
  onAccessResults: ({ email }: { email: string }) => void
  isLoading: boolean
  setModalSubscribeSimplifiedType: React.Dispatch<
    React.SetStateAction<SubscribeSimplifiedModalTypeEnum>
  >
  helperText: null | HelperTextProps
}) => {
  const { isSeminar } = useSeminarAppContext()

  return (
    <Modal
      isOpen={true}
      title={
        <div className={s.titleWrapper}>
          <IconSvg.ArrowLeft
            onClick={() =>
              (window.location.href = `${process.env.NEXT_PUBLIC_APP_URL}${getHomePathname(
                {
                  isSeminar,
                },
              )}`)
            }
            className={s.icon}
          />
          <p className={s.title}>
            <FormattedMessage
              id='ui.subscribeSimplifiedAccesResultsModal.title'
              defaultMessage='Entrez un e-mail professionnel pour voir les résultats'
            />
          </p>
        </div>
      }
      applyInnerStyle={false}
      className={s.subscribeSimplifiedAccesResultsModal}
      navBar={
        <div className={s.headerMobile}>
          <IconSvg.ArrowLeft
            onClick={() =>
              (window.location.href = `${process.env.NEXT_PUBLIC_APP_URL}${getHomePathname(
                {
                  isSeminar,
                },
              )}`)
            }
            className={s.icon}
          />
          <p className={s.title}>
            <FormattedMessage
              id='ui.subscribeSimplifiedAccesResultsModal.title'
              defaultMessage='Entrez un e-mail professionnel pour voir les résultats'
            />
          </p>
        </div>
      }
    >
      <SubscribeSimplifiedModalForm
        onAccessResults={onAccessResults}
        isLoading={isLoading}
        setModalSubscribeSimplifiedType={setModalSubscribeSimplifiedType}
        helperText={helperText}
      />
    </Modal>
  )
}

export default SubscribeSimplifiedAccesResultsModal
